import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'

import { signinValidateObject, SigninValidateObject } from '../validate'

export const useSigninForm = () => {
  const signinFormObject = useForm<SigninValidateObject>({
    defaultValues: {
      email: '',
      password: '',
    },
    mode: 'all',
    resolver: zodResolver(signinValidateObject),
  })
  return { signinFormObject }
}
